function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import c3 from 'c3/c3';
import LocaleKeys from '../../../../locales/keys';
import { getHexValueByUsage } from './usage.chart.helper';
var PieChartController = /*#__PURE__*/function () {
  function PieChartController(uiTetherProvider, $element, $scope) {
    _classCallCheck(this, PieChartController);
    Object.assign(this, {
      $element: $element,
      $scope: $scope,
      chart: null,
      uiTetherProvider: uiTetherProvider
    });
    this.$scope.LocaleKeys = LocaleKeys;
  }
  return _createClass(PieChartController, [{
    key: "$onChanges",
    value: function $onChanges() {
      Object.assign(this.$scope, {
        currencyCode: this.currencyCode,
        total: this.total,
        unitCode: this.unitCode,
        used: this.used,
        unitDisplayName: this.unitDisplayName,
        entitlementUsageLimits: this.entitlementUsageLimits,
        perServiceUsageLimits: this.perServiceUsageLimits,
        pricingVectorOverrides: this.pricingVectorOverrides
      });
      this.generateChart();
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      this.generateChart();
      this.uiTetherProvider({
        target: this.$element,
        scope: this.$scope,
        template: require('./pie.chart.popup.template.html')
      });
    }
  }, {
    key: "getPieData",
    value: function getPieData() {
      var remainingBalance = this.total - this.used; //exception: do not do maths in UI
      return {
        columns: [['used', this.used], ['remaining', remainingBalance]],
        colors: {
          remaining: 'transparent',
          used: getHexValueByUsage(this.used, remainingBalance)
        }
      };
    }
  }, {
    key: "generateChart",
    value: function generateChart() {
      if (this.chart) {
        this.chart.load(Object.assign({
          unload: true
        }, this.getPieData()));
      } else {
        this.cart = c3.generate({
          bindto: this.$element[0],
          data: Object.assign({
            type: 'pie',
            labels: false,
            order: null
          }, this.getPieData()),
          interaction: {
            enabled: false
          },
          tooltip: {
            show: false
          },
          legend: {
            show: false
          },
          pie: {
            label: {
              show: false
            }
          }
        });
      }
    }
  }]);
}();
export default {
  controller: PieChartController,
  bindings: {
    currencyCode: '<',
    total: '<',
    unitCode: '<',
    used: '<',
    unitDisplayName: '<?',
    entitlementUsageLimits: '=',
    perServiceUsageLimits: '=',
    pricingVectorOverrides: '='
  }
};